"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ValueMyCarButton_1 = __importDefault(require("./ValueMyCarButton"));
var YearMakeModelDropDowns_1 = __importDefault(require("./YearMakeModel/YearMakeModelDropDowns"));
var VinPlateWidget_1 = require("./VinPlate/VinPlateWidget");
var FormContext_1 = require("./Context/FormContext");
var Types_1 = require("./Types");
var ValuationWidgetContext_1 = require("./Context/ValuationWidgetContext");
var VinPlateToggle_1 = __importDefault(require("./VinPlate/VinPlateToggle"));
var UpgradeOfferButton_1 = __importDefault(require("./UpgradeOfferButton"));
var localization = window.Resources.ValuationWidgetResources;
var ValuationWidgetContent = function () {
    var formContext = (0, hooks_1.useContext)(FormContext_1.FormContext);
    var widgetContext = (0, hooks_1.useContext)(ValuationWidgetContext_1.ValuationWidgetContext);
    var getPlateType = function () {
        return widgetContext.getValuationMethod === Types_1.PublicValuationMethod.LicensePlate
            ? Types_1.ToggleSelectionChoice.LicensePlate
            : Types_1.ToggleSelectionChoice.VIN;
    };
    var _a = (0, hooks_1.useState)(getPlateType()), vinPlateType = _a[0], setVinPlateType = _a[1];
    // Reset form values if selection changes
    (0, hooks_1.useEffect)(function () {
        formContext.resetFormWithNewValue(function (x) {
            x.valuationMethod = widgetContext.currentValuationMethod;
        });
        setVinPlateType(getPlateType());
    }, [widgetContext.currentValuationMethod]);
    // Reset errors if inputs change
    (0, hooks_1.useEffect)(function () {
        widgetContext.resetErrorStateWithNewValue();
    }, [formContext.formValue]);
    function shouldShowVinPlateWidget() {
        return widgetContext.currentValuationMethod !== Types_1.PublicValuationMethod.YearMakeModelDropdowns;
    }
    function shouldShowUpgradeOfferButton() {
        return !widgetContext.getShowDropdowns;
    }
    function getContainerClasses() {
        var classes = [];
        if (formContext.isSubmitting) {
            classes.push('form-submitting');
        }
        classes.push(widgetContext.currentValuationMethod === Types_1.PublicValuationMethod.YearMakeModelDropdowns ? 'show-dropdowns' : 'show-vin-plate');
        return classes.join(' ');
    }
    return formContext && widgetContext && (0, preact_1.h)("div", { id: "selection-container", class: getContainerClasses() },
        !shouldShowUpgradeOfferButton() && ((0, preact_1.h)("h1", { id: "cta-header", className: "mobile-only" },
            (0, preact_1.h)("span", { className: "cta-trading-selling-question" }, localization.CTA_TradingInOrSelling),
            (0, preact_1.h)("span", { className: "cta-get-free-valuation-text" }, localization.CTA_GetYourFreeValuationNow))),
        widgetContext.getShowDropdowns && widgetContext.currentValuationMethod === Types_1.PublicValuationMethod.YearMakeModelDropdowns &&
            (0, preact_1.h)("div", { class: "return-to-home-link-container above" },
                (0, preact_1.h)("span", null,
                    localization.CTA_HeaderLink_ForMostAccurateValuation,
                    ","),
                (0, preact_1.h)("a", { class: "return-to-home-link green-link", onClick: function () { return widgetContext.updateValuationMethod(Types_1.PublicValuationMethod.Vin); } }, localization.CTA_HeaderLink_EnterYourVin),
                "or",
                (0, preact_1.h)("a", { class: "return-to-home-link green-link", onClick: function () { return widgetContext.updateValuationMethod(Types_1.PublicValuationMethod.LicensePlate); } }, localization.CTA_HeaderLink_Plate)),
        (0, preact_1.h)(VinPlateToggle_1.default, { selectionType: widgetContext.getValuationMethod, handleToggle: function (x) { return widgetContext.updateValuationMethod(x); }, showDropdowns: widgetContext.getShowDropdowns }),
        shouldShowVinPlateWidget()
            ? (0, preact_1.h)(VinPlateWidget_1.VinSelectionWidget, { vinPlateType: vinPlateType })
            : (0, preact_1.h)(YearMakeModelDropDowns_1.default, null),
        shouldShowUpgradeOfferButton()
            ? (0, preact_1.h)(UpgradeOfferButton_1.default, null)
            : (0, preact_1.h)(ValueMyCarButton_1.default, null));
};
exports.default = ValuationWidgetContent;
